import { Link } from 'react-router-dom';
import HeroCarousel, { type HeroSlide } from '@/pages/home/components/HeroCarousel';
import FilmCard from '@/components/feature/FilmCard';
import { getLatestFilms, getAllNews } from '@/lib/catalog';

const HERO_SLIDES: HeroSlide[] = [
  {
    id: 'dhyx',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20scene%20of%20a%20stormy%20deep%20blue%20ocean%20with%20a%20lone%20diver%20silhouette%20and%20a%20warm%20orange%20horizon%20glow%2C%20moody%20atmospheric%20film%20banner%2C%20dark%20left%20side%20for%20text%20contrast&width=1600&height=900&seq=hero-dhyx-01&orientation=landscape',
    tag: '电影 · 热映中',
    title: '《深海回响》',
    subtitle:
      '一场跨越十年的深海救援，将一名潜水工程师的秘密与一座沿海城市的命运紧紧缠绕。压力与黑暗之中，她必须重新面对自己最深的恐惧。',
  },
  {
    id: 'djjs',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20tokyo%20city%20skyline%20at%20night%20with%20warm%20orange%20window%20lights%20against%20deep%20blue%20dusk%20sky%2C%20moody%20urban%20film%20banner%20with%20darker%20left%20side&width=1600&height=900&seq=hero-djjs-01&orientation=landscape',
    tag: '电视剧 · 全 10 集',
    title: '《东京纪事》',
    subtitle:
      '深夜咖啡馆里，五位素不相识的人因一杯咖啡相遇。片段式叙事勾勒都市人的孤独与温柔，神宫寺奈绪饰演的店主是全剧的情感锚点。',
  },
  {
    id: 'yhc',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20night%20ferry%20crossing%20dark%20deep%20blue%20ocean%20with%20warm%20orange%20deck%20lights%20and%20mist%2C%20mysterious%20thriller%20film%20banner%20with%20darker%20left%20area&width=1600&height=900&seq=hero-yhc-01&orientation=landscape',
    tag: '电视剧 · 悬疑新作',
    title: '《夜航船》',
    subtitle:
      '一艘夜间渡轮上的六名乘客，各自带着不能说出口的秘密。航线推进，真相在夜色与海浪声中被一点点推向甲板。',
  },
];

const TYPE_ENTRIES = [
  {
    type: '电影',
    icon: 'ri-film-line',
    desc: '院线与艺术佳作',
  },
  {
    type: '电视剧',
    icon: 'ri-tv-2-line',
    desc: '都市、悬疑与治愈剧集',
  },
  {
    type: '综艺',
    icon: 'ri-mic-line',
    desc: '真人秀与旅行综艺',
  },
];

export default function Home() {
  const latestFilms = getLatestFilms(6);
  const latestNews = getAllNews().slice(0, 4);

  return (
    <div className="w-full">
      <HeroCarousel slides={HERO_SLIDES} />

      {/* 分类快捷入口 */}
      <section className="px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
          {TYPE_ENTRIES.map((entry) => (
            <Link
              key={entry.type}
              to={`/category?type=${encodeURIComponent(entry.type)}`}
              className="group flex items-center gap-4 p-5 md:p-6 bg-background-100 border border-background-200 rounded-lg hover:border-accent-300 transition-colors cursor-pointer"
            >
              <span className="w-14 h-14 md:w-16 md:h-16 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center text-2xl md:text-3xl shrink-0 group-hover:bg-accent-100 group-hover:text-accent-700 transition-colors">
                <i className={entry.icon}></i>
              </span>
              <span className="min-w-0">
                <span className="block font-heading font-bold text-foreground-950 text-lg md:text-xl">
                  {entry.type}
                </span>
                <span className="block mt-1 text-xs md:text-sm text-foreground-500">{entry.desc}</span>
              </span>
              <i className="ri-arrow-right-line ml-auto text-foreground-300 group-hover:text-accent-500 transition-colors"></i>
            </Link>
          ))}
        </div>
      </section>

      {/* 最新影视作品 */}
      <section className="px-4 md:px-6 py-12 md:py-16 bg-background-100">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="text-accent-600 text-sm font-medium tracking-widest">LATEST WORKS</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              最新影视作品
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-500">
              精选最新上线与热门作品，覆盖电影、电视剧与综艺
            </p>
          </div>
          <Link
            to="/category"
            className="self-start sm:self-auto px-5 h-10 rounded-md border border-primary-300 text-primary-700 hover:bg-primary-50 text-sm flex items-center gap-2 whitespace-nowrap transition-colors cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {latestFilms.map((film) => (
            <FilmCard key={film.id} film={film} />
          ))}
        </div>
      </section>

      {/* 最新资讯 */}
      <section className="px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="text-accent-600 text-sm font-medium tracking-widest">NEWS & UPDATES</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              最新资讯动态
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-500">
              第一时间了解神宫寺奈绪的演艺动态与作品消息
            </p>
          </div>
          <Link
            to="/news"
            className="self-start sm:self-auto px-5 h-10 rounded-md border border-primary-300 text-primary-700 hover:bg-primary-50 text-sm flex items-center gap-2 whitespace-nowrap transition-colors cursor-pointer"
          >
            全部资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
          {latestNews.map((item) => (
            <Link
              key={item.id}
              to={`/news/${item.id}`}
              className="group flex gap-4 p-4 bg-background-50 border border-background-200 rounded-lg hover:border-accent-300 transition-colors cursor-pointer"
            >
              <div className="w-24 h-24 md:w-32 md:h-28 rounded-md overflow-hidden bg-background-200 shrink-0">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={`${item.title} 神宫寺奈绪娱乐资讯`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="min-w-0 flex flex-col">
                <span className="text-xs text-accent-600 font-medium">{item.date}</span>
                <h3 className="mt-1.5 text-sm md:text-base font-medium text-foreground-950 line-clamp-2 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-500 line-clamp-2 hidden sm:block">
                  {item.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* 网站简介 */}
      <section className="px-4 md:px-6 py-12 md:py-16 bg-background-100">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
          <div className="rounded-lg overflow-hidden aspect-[16/10] bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=artistic%20cinema%20concept%20with%20film%20reels%20and%20theatre%20seats%20in%20warm%20orange%20and%20deep%20blue%20tones%2C%20minimal%20editorial%20composition%2C%20soft%20lighting&width=1200&height=750&seq=intro-banner-01&orientation=landscape"
              alt="神宫寺奈绪影视内容站"
              title="神宫寺奈绪影视内容站 演艺资料与作品介绍"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <span className="text-accent-600 text-sm font-medium tracking-widest">ABOUT THE SITE</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              关于神宫寺奈绪影视内容站
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              本站专注于整理与呈现神宫寺奈绪相关的电影、电视剧、综艺作品，以及最新的娱乐资讯与演艺资料。
              我们希望通过清晰、系统的内容组织，让每一位粉丝都能便捷地浏览作品介绍、掌握最新动态，更深入地了解她台前幕后的故事。
            </p>
            <div className="mt-7 grid grid-cols-3 gap-4">
              <div>
                <p className="font-heading text-2xl md:text-3xl font-bold text-primary-700">12+</p>
                <p className="mt-1 text-xs md:text-sm text-foreground-500">收录作品</p>
              </div>
              <div>
                <p className="font-heading text-2xl md:text-3xl font-bold text-accent-600">8+</p>
                <p className="mt-1 text-xs md:text-sm text-foreground-500">资讯动态</p>
              </div>
              <div>
                <p className="font-heading text-2xl md:text-3xl font-bold text-primary-700">3</p>
                <p className="mt-1 text-xs md:text-sm text-foreground-500">作品类型</p>
              </div>
            </div>
            <Link
              to="/about"
              className="mt-8 inline-flex px-6 h-11 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium items-center gap-2 whitespace-nowrap transition-colors cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}